export default __webpack_public_path__ + "static/media/web_screen_meetings_ja.a05c8fcc.png";